var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.innerVisible,
        width: "700px",
        "custom-class": "sysop-dialog",
        "append-to-body": "",
        "close-on-press-escape": false,
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.innerVisible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "sd-head" }, [
        _c("span", { staticClass: "sd-ico" }, [
          _c(
            "svg",
            {
              attrs: {
                width: "14",
                height: "14",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
              },
            },
            [
              _c("circle", { attrs: { cx: "11", cy: "11", r: "8" } }),
              _c("path", { attrs: { d: "m21 21-4.35-4.35" } }),
            ]
          ),
        ]),
        _c("div", { staticClass: "sd-title" }, [
          _c("span", [_vm._v(_vm._s(_vm.title))]),
          _c("span", { staticClass: "sd-pt" }, [_vm._v(_vm._s(_vm.titlePt))]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "sd-body" },
        [
          _c("div", { staticClass: "alert alert-info" }, [
            _c(
              "svg",
              {
                staticClass: "ico",
                attrs: {
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "1.8",
                },
              },
              [
                _c("circle", { attrs: { cx: "12", cy: "12", r: "10" } }),
                _c("path", { attrs: { d: "M12 16v-4M12 8h.01" } }),
              ]
            ),
            _c("span", { staticClass: "alert-text" }, [
              _c("span", [
                _vm._v(
                  ' 系统配置由代码侧控制。点击"开始检索"会在仓库内搜索该州的 CTE/MDFE 开票主体代码配置，检索到则状态变更为'
                ),
                _c("b", { staticClass: "ok" }, [_vm._v("已配置")]),
                _vm._v("，未检索到则保持"),
                _c("b", { staticClass: "err" }, [_vm._v("未配置")]),
                _vm._v("。 "),
              ]),
              _c("span", { staticClass: "alert-pt" }, [
                _vm._v(
                  ' A configuração do sistema é controlada pelo código. Clique em "Iniciar Busca" para procurar no repositório a configuração de código da entidade emissora de CT-e/MDF-e deste estado; se encontrada, o status muda para '
                ),
                _c("b", { staticClass: "ok" }, [_vm._v("Configurado")]),
                _vm._v("; se não encontrada, permanece "),
                _c("b", { staticClass: "err" }, [_vm._v("Não Configurado")]),
                _vm._v(". "),
              ]),
            ]),
          ]),
          _c(
            "el-form",
            {
              attrs: {
                model: _vm.form,
                "label-position": "top",
                size: "small",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("bi-label", {
                                attrs: { zh: "UF", pt: "UF", inline: "" },
                              }),
                            ],
                            1
                          ),
                          _c("el-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.form.uf,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "uf", $$v)
                              },
                              expression: "form.uf",
                            },
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("bi-label", {
                                attrs: {
                                  zh: "公司名称",
                                  pt: "Razão Social",
                                  inline: "",
                                },
                              }),
                            ],
                            1
                          ),
                          _c("el-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.form.companyName,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "companyName", $$v)
                              },
                              expression: "form.companyName",
                            },
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 16 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("bi-label", {
                                attrs: { zh: "CNPJ", pt: "CNPJ", inline: "" },
                              }),
                            ],
                            1
                          ),
                          _c("el-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.form.cnpj,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "cnpj", $$v)
                              },
                              expression: "form.cnpj",
                            },
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("bi-label", {
                                attrs: {
                                  zh: "当前状态",
                                  pt: "Status Atual",
                                  inline: "",
                                },
                              }),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "sd-status" }, [
                            _c(
                              "span",
                              { staticClass: "tag", class: _vm.tagCls },
                              [
                                _c("span", { staticClass: "dot" }),
                                _vm._v(_vm._s(_vm.sysText) + " "),
                                _c("span", { staticClass: "tag-pt" }, [
                                  _vm._v("/ " + _vm._s(_vm.sysTextPt)),
                                ]),
                              ]
                            ),
                          ]),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm.result || _vm.searching
            ? _c("div", { staticClass: "sd-result" }, [
                _vm.searching
                  ? _c("div", { staticClass: "alert alert-info" }, [
                      _c(
                        "svg",
                        {
                          staticClass: "ico",
                          attrs: {
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "1.8",
                          },
                        },
                        [
                          _c("circle", {
                            attrs: { cx: "12", cy: "12", r: "10" },
                          }),
                          _c("path", { attrs: { d: "M12 16v-4M12 8h.01" } }),
                        ]
                      ),
                      _c("span", { staticClass: "alert-text" }, [
                        _c("span", [
                          _vm._v(" 正在扫描代码库，匹配 "),
                          _c("code", [
                            _vm._v(
                              "aujun-billing-config/" +
                                _vm._s(_vm.form.uf) +
                                "/issuer.json"
                            ),
                          ]),
                          _vm._v(" 与 "),
                          _c("code", [_vm._v("CTEProviderConfig")]),
                          _vm._v("… "),
                        ]),
                        _c("span", { staticClass: "alert-pt" }, [
                          _vm._v(" Varrendo o repositório: "),
                          _c("code", [
                            _vm._v(
                              "aujun-billing-config/" +
                                _vm._s(_vm.form.uf) +
                                "/issuer.json"
                            ),
                          ]),
                          _vm._v(" e "),
                          _c("code", [_vm._v("CTEProviderConfig")]),
                          _vm._v("… "),
                        ]),
                      ]),
                    ])
                  : _vm.result === "ok"
                  ? _c("div", { staticClass: "alert alert-ok" }, [
                      _c(
                        "svg",
                        {
                          staticClass: "ico",
                          attrs: {
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "1.8",
                          },
                        },
                        [
                          _c("circle", {
                            attrs: { cx: "12", cy: "12", r: "10" },
                          }),
                          _c("path", { attrs: { d: "m9 12 2 2 4-4" } }),
                        ]
                      ),
                      _c("span", { staticClass: "alert-text" }, [
                        _c("span", [
                          _vm._v(" 检索成功："),
                          _c("b", [_vm._v(_vm._s(_vm.form.uf))]),
                          _vm._v(" 已在 "),
                          _c("code", [
                            _vm._v(
                              "aujun-billing-config/" +
                                _vm._s(_vm.form.uf) +
                                "/"
                            ),
                          ]),
                          _vm._v(" 找到开票主体配置，已更新为"),
                          _c("b", { staticClass: "ok" }, [_vm._v("已配置")]),
                          _vm._v("。 "),
                        ]),
                        _c("span", { staticClass: "alert-pt" }, [
                          _vm._v(" Busca concluída: "),
                          _c("b", [_vm._v(_vm._s(_vm.form.uf))]),
                          _vm._v(" encontrado em "),
                          _c("code", [
                            _vm._v(
                              "aujun-billing-config/" +
                                _vm._s(_vm.form.uf) +
                                "/"
                            ),
                          ]),
                          _vm._v("; status atualizado para "),
                          _c("b", { staticClass: "ok" }, [
                            _vm._v("Configurado"),
                          ]),
                          _vm._v(". "),
                        ]),
                      ]),
                    ])
                  : _c("div", { staticClass: "alert alert-err" }, [
                      _c(
                        "svg",
                        {
                          staticClass: "ico",
                          attrs: {
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            "stroke-width": "1.8",
                          },
                        },
                        [
                          _c("circle", {
                            attrs: { cx: "12", cy: "12", r: "10" },
                          }),
                          _c("path", { attrs: { d: "M12 7.4v5.6" } }),
                          _c("circle", {
                            attrs: {
                              cx: "12",
                              cy: "16.6",
                              r: "1.15",
                              fill: "currentColor",
                              stroke: "none",
                            },
                          }),
                        ]
                      ),
                      _c("span", { staticClass: "alert-text" }, [
                        _c("span", [
                          _vm._v(" 未检索到 "),
                          _c("b", [_vm._v(_vm._s(_vm.form.uf))]),
                          _vm._v(" 的开票主体代码配置。请先在仓库内创建 "),
                          _c("code", [
                            _vm._v(
                              "aujun-billing-config/" +
                                _vm._s(_vm.form.uf) +
                                "/issuer.json"
                            ),
                          ]),
                          _vm._v(" 后重新检索。 "),
                        ]),
                        _c("span", { staticClass: "alert-pt" }, [
                          _vm._v(
                            " Não encontrada a configuração de código de "
                          ),
                          _c("b", [_vm._v(_vm._s(_vm.form.uf))]),
                          _vm._v(". Crie "),
                          _c("code", [
                            _vm._v(
                              "aujun-billing-config/" +
                                _vm._s(_vm.form.uf) +
                                "/issuer.json"
                            ),
                          ]),
                          _vm._v(" no repositório e busque novamente. "),
                        ]),
                      ]),
                    ]),
              ])
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small" },
              on: {
                click: function ($event) {
                  _vm.innerVisible = false
                },
              },
            },
            [
              _c("bi-label", {
                attrs: { zh: "关闭", pt: "Fechar", inline: "" },
              }),
            ],
            1
          ),
          _vm.sysStatus === 1
            ? _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "warning",
                    loading: _vm.searching,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.handleSearch(2)
                    },
                  },
                },
                [
                  _vm._v(" 取消配置"),
                  _c("span", { staticClass: "btn-pt" }, [
                    _vm._v(" / Cancelar configuração"),
                  ]),
                ]
              )
            : _vm._e(),
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary", loading: _vm.searching },
              on: {
                click: function ($event) {
                  return _vm.handleSearch(1)
                },
              },
            },
            [
              _vm._v(" " + _vm._s(_vm.btnText)),
              _c("span", { staticClass: "btn-pt" }, [
                _vm._v(" / " + _vm._s(_vm.btnTextPt)),
              ]),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }